import { render, staticRenderFns } from "./ApproveEditor.vue?vue&type=template&id=a9e07a62&scoped=true&"
import script from "./ApproveEditor.vue?vue&type=script&lang=js&"
export * from "./ApproveEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e07a62",
  null
  
)

export default component.exports